import React from "react";
import mainBg from "../../../assets/visa-requirements/main-bg.png";
import { Select } from "antd";
import { useTranslation } from "react-i18next";

interface CountryGroup {
  region: string;
  countries: {
    name: string;
    code: string;
    japaneseName: string;
    chineseName: string;
    koreanName: string;
  }[];
}

interface RequirementsHeroSectionProps {
  countries: CountryGroup[];
  setSelectedCountry: (value: string) => void;
}

const RequirementsHeroSection: React.FC<RequirementsHeroSectionProps> = ({
  countries,
  setSelectedCountry,
}) => {
  const { t } = useTranslation();
  return (
    <div
      className="w-full h-[500px] flex justify-center items-center px-6"
      style={{
        backgroundImage: `url(${mainBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        opacity: 0.9,
        filter: "brightness(0.9)",
      }}
    >
      <div className="w-full h-full max-w-standard flex flex-col justify-center items-center gap-20">
        <p className="!text-white lg:!text-[80px] md:!text-6xl !text-4xl !font-extrabold mb-[40px]">
          {t("visa_requirements.title")}
        </p>
        <p className="!text-white lg:text-[32px] text-xl !font-semibold text-center">
          {t("visa_requirements.select_country")}
        </p>

        <Select
          showSearch
          size="large"
          className="w-full max-w-xl h-10 !rounded-2xl"
          placeholder={t("apply_visa.select_country_placeholder")}
          optionFilterProp="children"
          onChange={setSelectedCountry}
          filterOption={(input, option) =>
            (option?.label?.toString() ?? "")
              .toLowerCase()
              .includes(input.toLowerCase())
          }
          options={countries.flatMap((group) =>
            group.countries.map((country) => ({
              label:
                localStorage.getItem("i18nextLng") === "en"
                  ? country.name
                  : localStorage.getItem("i18nextLng") === "jp"
                  ? country.japaneseName
                  : localStorage.getItem("i18nextLng") === "cn"
                  ? country.chineseName
                  : country.koreanName,
              value: country.name,
              group: group.region,
            }))
          )}
        />
      </div>
    </div>
  );
};

export default RequirementsHeroSection;
